import { removeUndefinedFieldsFromObject } from '@vfde-brix/ws10/core';
import {
    ButtonIconOnly,
    IButtonIconOnlyBusinessLogic,
    IButtonIconOnlyProperties,
    createButtonIconOnly,
} from '@vfde-brix/ws10/button-icon-only';
import { BUTTON_COLOR_SECONDARY } from '@vfde-brix/ws10/button';
import { IButtonIconOnlyOptionalParams } from 'Container/CancellationForm/interface';

/**
 * Create and mount button icon only ws10 component
 */
export const mountButtonIconOnly = (containerElementId: string, optionalProps: IButtonIconOnlyOptionalParams): ButtonIconOnly | null => {
    const { stdIconName, onClick } = optionalProps;
    const containerElement = document.getElementById(containerElementId);
    const business: IButtonIconOnlyBusinessLogic = onClick ? { onClick } : {};
    const props = <IButtonIconOnlyProperties>removeUndefinedFieldsFromObject({
        optColor: BUTTON_COLOR_SECONDARY,
        stdIconName,
        stdAriaLabel: '',
        business,
    });

    return containerElement && createButtonIconOnly(containerElement, props);
};
